export default __webpack_public_path__ + "static/media/poweredby.064d0d64.png";